import widgetLanguages from './widgetLanguages';
import getWordForm, { WORD_FORMS } from '../../../helpers/getWordForm';

const WT = {
  person: {
    [widgetLanguages.ru.code]: (count) => getWordForm(count, WORD_FORMS.person),
    [widgetLanguages.en.code]: (count) => (count === 1 ? 'person' : 'persons'),
    [widgetLanguages.am.code]: (count) => 'մարդ',
    [widgetLanguages.kz.code]: (count) => (count === 1 ? 'адам' : 'адамдар'),
  },
  policy1: {
    [widgetLanguages.ru.code]: (buttonText) => `Нажимая кнопку “${buttonText}” Вы принимаете условия `,
    [widgetLanguages.en.code]: (buttonText) => `By clicking the “${buttonText}” button you accept the terms of `,
    [widgetLanguages.am.code]: (buttonText) => `Սեղմելով “${buttonText}” կոճակը՝ դուք ընդունում եք `,
    [widgetLanguages.kz.code]: (buttonText) => `“${buttonText}” түймесін басу арқылы сіз `,
  },
  policy2: {
    [widgetLanguages.ru.code]: () => 'пользовательского соглашения и политики конфиденциальности',
    [widgetLanguages.en.code]: () => 'the user agreement and privacy policy',
    [widgetLanguages.am.code]: () => 'օգտագործողի համաձայնագրի և գաղտնիության քաղաքականության պայմանները',
    [widgetLanguages.kz.code]: () => 'пайдаланушы келісімінің жәнеқұпиялылық саясатының шарттарын қабылдайсыз',
  },
  chooseTime: {
    [widgetLanguages.ru.code]: () => 'Выберите время',
    [widgetLanguages.en.code]: () => 'Choose time',
    [widgetLanguages.am.code]: () => 'Ընտրեք ժամը',
    [widgetLanguages.kz.code]: () => 'Уақытты таңдаңыз',
  },
  afterMidnight: {
    [widgetLanguages.ru.code]: () => '(после полуночи)',
    [widgetLanguages.en.code]: () => '(after midnight)',
    [widgetLanguages.am.code]: () => '(կեսգիշերից հետո)',
    [widgetLanguages.kz.code]: () => '(түнгі жартыдан кейін)',
  },
  loading: {
    [widgetLanguages.ru.code]: () => 'Загрузка...',
    [widgetLanguages.en.code]: () => 'Loading...',
    [widgetLanguages.am.code]: () => 'Բեռնվում է...',
    [widgetLanguages.kz.code]: () => 'Жүктелуде...',
  },
  noSlotsForDate: {
    [widgetLanguages.ru.code]: () => 'На эту дату свободных слотов не найдено',
    [widgetLanguages.en.code]: () => 'No available slots found for this date',
    [widgetLanguages.am.code]: () => 'Այս ամսաթվի համար ազատ ժամեր չեն գտնվել',
    [widgetLanguages.kz.code]: () => 'Осы күнге бос уақыт табылмады',
  },
  yourName: {
    [widgetLanguages.ru.code]: () => 'Ваше имя',
    [widgetLanguages.en.code]: () => 'Your name',
    [widgetLanguages.am.code]: () => 'Ձեր անունը',
    [widgetLanguages.kz.code]: () => 'Сіздің атыңыз',
  },
  yourNumber: {
    [widgetLanguages.ru.code]: () => 'Ваш телефон',
    [widgetLanguages.en.code]: () => 'Your phone number',
    [widgetLanguages.am.code]: () => 'Ձեր հեռախոսահամարը',
    [widgetLanguages.kz.code]: () => 'Сіздің телефон нөміріңіз',
  },
  namePlaceholder: {
    [widgetLanguages.ru.code]: () => 'Иван',
    [widgetLanguages.en.code]: () => 'John',
    [widgetLanguages.am.code]: () => 'Հովհաննես',
    [widgetLanguages.kz.code]: () => 'Ержан',
  },
  bookingRequests: {
    [widgetLanguages.ru.code]: () => 'Пожелания к бронированию',
    [widgetLanguages.en.code]: () => 'Booking requests',
    [widgetLanguages.am.code]: () => 'Ամրագրումների պահանջներ',
    [widgetLanguages.kz.code]: () => 'Брондау сұраныстары',
  },
  book: {
    [widgetLanguages.ru.code]: () => 'Забронировать',
    [widgetLanguages.en.code]: () => 'Book',
    [widgetLanguages.am.code]: () => 'Ամրագրել',
    [widgetLanguages.kz.code]: () => 'Брондау',
  },
  successfullyCreated: {
    [widgetLanguages.ru.code]: () => 'Ваш столик успешно забронирован, будем рады видеть вас!',
    [widgetLanguages.en.code]: () => 'Your table has been successfully booked, we look forward to seeing you!',
    [widgetLanguages.am.code]: () => 'Ձեր սեղանը հաջողությամբ ամրագրվել է, մենք ուրախ կլինենք տեսնել ձեզ!',
    [widgetLanguages.kz.code]: () => 'Сіздің үстеліңіз сәтті брондалды, біз сізді көруге қуаныштымыз!',
  },
  cancelBooking: {
    [widgetLanguages.ru.code]: () => 'Прекратить бронирование?',
    [widgetLanguages.en.code]: () => 'Cancel booking?',
    [widgetLanguages.am.code]: () => 'Դադարեցնել ամրագրումը՞',
    [widgetLanguages.kz.code]: () => 'Брондауды тоқтату керек пе?',
  },
  cancel: {
    [widgetLanguages.ru.code]: () => 'Прекратить',
    [widgetLanguages.en.code]: () => 'Cancel',
    [widgetLanguages.am.code]: () => 'Դադարեցնել',
    [widgetLanguages.kz.code]: () => 'Тоқтату',
  },
  continue: {
    [widgetLanguages.ru.code]: () => 'Продолжить',
    [widgetLanguages.en.code]: () => 'Continue',
    [widgetLanguages.am.code]: () => 'Շարունակել',
    [widgetLanguages.kz.code]: () => 'Жалғастыру',
  },
  close: {
    [widgetLanguages.ru.code]: () => 'Закрыть',
    [widgetLanguages.en.code]: () => 'Close',
    [widgetLanguages.am.code]: () => 'Փակել',
    [widgetLanguages.kz.code]: () => 'Жабу',
  },
  repeat: {
    [widgetLanguages.ru.code]: () => 'Повторить',
    [widgetLanguages.en.code]: () => 'Repeat',
    [widgetLanguages.am.code]: () => 'Կրկնել',
    [widgetLanguages.kz.code]: () => 'Қайталау',
  },
  share: {
    [widgetLanguages.ru.code]: () => 'Поделитесь с друзьями!',
    [widgetLanguages.en.code]: () => 'Share with friends!',
    [widgetLanguages.am.code]: () => 'Կիսվեք ընկերների հետ!',
    [widgetLanguages.kz.code]: () => 'Достарыңызбен бөлісіңіз!',
  },
  afterBook: {
    [widgetLanguages.ru.code]: ({
      date, count, name, address,
    }) => `Стол забронирован на ${date} на ${count} ${getWordForm(count, WORD_FORMS.forPerson)} в "${name}" по адресу: ${address}`,
    [widgetLanguages.en.code]: ({
      date, count, name, address,
    }) => `The table is reserved for ${date} for ${count} person at "${name}" at ${address}.`,
    [widgetLanguages.am.code]: ({
      date, count, name, address,
    }) => `Սեղանը ամրագրված է ${date}, ${count} անձի համար "${name}" ռեստորանում, ${address}։`,
    [widgetLanguages.kz.code]: ({
      date, count, name, address,
    }) => `Үстел ${date}, ${count} адамға "${name}" мейрамханасында, ${address} брондалған.`,
  },
};

export default WT;
